import { CurrentHealthcareProviderInvoicePdfQuery, InvoicePdf } from '@dreryk/egabinet-invoice-frontend-api';

import { performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';
import { downloadDocumentAsPdf } from '@dreryk/react-common';

import { invoiceTranslationKeys } from '../../translations';

export const downloadInvoiceAsPdf = (referenceId: string) => {
   return async (): Promise<void> => {
      try {
         const result = await performCqrsQueryGet<InvoicePdf>(() => {
            const query = new CurrentHealthcareProviderInvoicePdfQuery();
            query.referenceId = Slot.of(referenceId);
            return query;
         });

         const userAgent = navigator.userAgent.toLowerCase();
         const isNotFirefox = !userAgent.includes('firefox');

         if (result) {
            downloadDocumentAsPdf({
               base64: result.data,
               fileName: result.fileName,
               openInNewTab: isNotFirefox,
            });
         }
      } catch (error) {
         dispatchSnackbarNegativeEvent(invoiceTranslationKeys.invoiceDownloadError);
      }
   };
};
